export const subtypeMap = new Map<string, string>([
  ['AA', 'Treasury'],
  ['BA', 'Agency Callable'],
  ['BB', 'Agency'],
  ['BC', 'Agency Step-Up'],
  ['BD', 'Agency Sink'],
  ['CC', 'Agency Flt'],
  ['DD', 'Corp Fx'],
  ['EE', 'Corp Flt'],
  ['FA', 'Tax Muni Underwriting'],
  // PreRefunded-ET
  ['FB', 'Tax Muni PreRe'],
  ['FC', 'Tax Muni BQ'],
  ['FD', 'Tax Muni GM'],
  // Pre-Tefr
  ['FE', 'Tax Muni'],
  ['FF', 'Tax Muni Safe-Harbor'],
  ['GA', 'Muni Underwriting'],
  // PreRefunded-ET
  ['GG', 'Muni PreRe'],
  ['GB', 'Muni BQ'],
  ['GC', 'Muni GM'],
  ['GD', 'Muni GM'],
  ['GE', 'Muni'],
  ['GF', 'Muni Safe-Harbor'],
  ['HH', 'CD'],
  ['IA', '10Yr'],
  ['IB', '15Yr'],
  ['IC', '20Yr'],
  ['ID', '25Yr'],
  ['IG', '7Yr Bln'],
  ['IH', '5Yr Bln'],
  ['II', 'Other Bln'],
  ['IL', 'Loans'],
  ['JJ', 'SBA Fx'],
  ['KK', 'SBA Flt'],
  ['LL', 'CMO Fx'],
  ['MM', 'CMO Flt']
]);
